import {
  CUSTOMER_LOGIN_FAIL,
  CUSTOMER_LOGIN_REQUEST,
  CUSTOMER_LOGIN_SUCCESS,
  CUSTOMER_LOGIN_RESET,
  SEND_OTP_REQUECT,
  SEND_OTP_SUCCESS,
  SEND_OTP_FAIL,
  SEND_OTP_RESET,
  CUSTOMER_LOGOUT,
  GET_LOGGED_IN_CUSTOMER_REQUEST,
  GET_LOGGED_IN_CUSTOMER_SUCCESS,
  GET_LOGGED_IN_CUSTOMER_FAIL,
  GET_LOGGED_IN_CUSTOMER_RESET,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAIL,
  CHANGE_PASSWORD_RESET,
  CREATE_CUSTOMER_USER_REQUEST,
  CREATE_CUSTOMER_USER_SUCCESS,
  CREATE_CUSTOMER_USER_FAIL,
  CREATE_CUSTOMER_USER_RESET,
  GET_CUSTOMER_USERS_REQUEST,
  GET_CUSTOMER_USERS_SUCCESS,
  GET_CUSTOMER_USERS_FAIL,
  GET_CUSTOMER_USERS_RESET,
  GET_CUSTOMER_USER_BY_ID_REQUEST,
  GET_CUSTOMER_USER_BY_ID_SUCCESS,
  GET_CUSTOMER_USER_BY_ID_FAIL,
  GET_CUSTOMER_USER_BY_ID_RESET,
  UPDATE_CUSTOMER_USER_REQUEST,
  UPDATE_CUSTOMER_USER_SUCCESS,
  UPDATE_CUSTOMER_USER_FAIL,
  UPDATE_CUSTOMER_USER_RESET,
  DELETE_CUSTOMER_USER_REQUEST,
  DELETE_CUSTOMER_USER_SUCCESS,
  DELETE_CUSTOMER_USER_FAIL,
  DELETE_CUSTOMER_USER_RESET,
  GET_CUSTOMER_USER_PERMISSION_REQUEST,
  GET_CUSTOMER_USER_PERMISSION_SUCCESS,
  GET_CUSTOMER_USER_PERMISSION_FAIL,
  GET_CUSTOMER_USER_PERMISSION_RESET,
  GET_LOGGED_IN_CUSTOMER_LOGINS_REQUEST,
  GET_LOGGED_IN_CUSTOMER_LOGINS_SUCCESS,
  GET_LOGGED_IN_CUSTOMER_LOGINS_FAIL,
  GET_LOGGED_IN_CUSTOMER_LOGINS_RESET,
  UPDATE_CUSTOMER_PROFILE_REQUEST,
  UPDATE_CUSTOMER_PROFILE_SUCCESS,
  UPDATE_CUSTOMER_PROFILE_FAIL,
  UPDATE_CUSTOMER_PROFILE_RESET,
  GET_ALL_COUNTRY_REQUEST,
  GET_ALL_COUNTRY_SUCCESS,
  GET_ALL_COUNTRY_FAIL,
  GET_ALL_COUNTRY_RESET,
  CHANGE_PASSWORD_FROM_PROFILE_REQUEST,
  CHANGE_PASSWORD_FROM_PROFILE_SUCCESS,
  CHANGE_PASSWORD_FROM_PROFILE_FAIL,
  CHANGE_PASSWORD_FROM_PROFILE_RESET,
  GET_MANAGE_BOOKING_DATA_REQUEST,
  GET_MANAGE_BOOKING_DATA_SUCCESS,
  GET_MANAGE_BOOKING_DATA_FAIL,
  GET_MANAGE_BOOKING_DATA_RESET,
  CHECK_LOGGED_IN_USER_PCC_REQUEST,
  CHECK_LOGGED_IN_USER_PCC_SUCCESS,
  CHECK_LOGGED_IN_USER_PCC_FAIL,
  CHECK_LOGGED_IN_USER_PCC_RESET,
  PRINT_ITINERARY_DATA_REQUEST,
  PRINT_ITINERARY_DATA_SUCCESS,
  PRINT_ITINERARY_DATA_FAIL,
  PRINT_ITINERARY_DATA_RESET,
  EMAIL_ITINERARY_DATA_REQUEST,
  EMAIL_ITINERARY_DATA_SUCCESS,
  EMAIL_ITINERARY_DATA_FAIL,
  EMAIL_ITINERARY_DATA_RESET,
  CHECK_CUSTOMER_USER_USERNAME_AVAILABILITY_REQUEST,
  CHECK_CUSTOMER_USER_USERNAME_AVAILABILITY_SUCCESS,
  CHECK_CUSTOMER_USER_USERNAME_AVAILABILITY_FAIL,
  CHECK_CUSTOMER_USER_USERNAME_AVAILABILITY_RESET,
  GET_LOGGED_IN_CUSTOMER_USER_REQUEST,
  GET_LOGGED_IN_CUSTOMER_USER_SUCCESS,
  GET_LOGGED_IN_CUSTOMER_USER_FAIL,
  GET_LOGGED_IN_CUSTOMER_USER_RESET,
  UPDATE_CUSTOMER_USER_PROFILE_REQUEST,
  UPDATE_CUSTOMER_USER_PROFILE_SUCCESS,
  UPDATE_CUSTOMER_USER_PROFILE_FAIL,
  UPDATE_CUSTOMER_USER_PROFILE_RESET,
  GET_CUSTOMER_USER_LOGOS_REQUEST,
  GET_CUSTOMER_USER_LOGOS_SUCCESS,
  GET_CUSTOMER_USER_LOGOS_FAIL,
  GET_CUSTOMER_USER_LOGOS_RESET,
  DELETE_CUSTOMER_USER_LOGO_REQUEST,
  DELETE_CUSTOMER_USER_LOGO_SUCCESS,
  DELETE_CUSTOMER_USER_LOGO_FAIL,
  DELETE_CUSTOMER_USER_LOGO_RESET,
  GET_TICKET_REPORT_REQUEST,
  GET_TICKET_REPORT_SUCCESS,
  GET_TICKET_REPORT_FAIL,
  GET_TICKET_REPORT_RESET,
  GET_TP_BATCH_REPORT_REQUEST,
  GET_TP_BATCH_REPORT_SUCCESS,
  GET_TP_BATCH_REPORT_FAIL,
  GET_TP_BATCH_REPORT_RESET,
  GET_CURRENCY_REQUEST,
  GET_CURRENCY_SUCCESS,
  GET_CURRENCY_FAIL,
  GET_CURRENCY_RESET,
  DOWNLOAD_EXCEL_REQUEST,
  DOWNLOAD_EXCEL_SUCCESS,
  DOWNLOAD_EXCEL_FAIL,
  DOWNLOAD_EXCEL_RESET,
  DOWNLOAD_CSV_REQUEST,
  DOWNLOAD_CSV_SUCCESS,
  DOWNLOAD_CSV_FAIL,
  DOWNLOAD_CSV_RESET,
  DOWNLOAD_INVOICE_REQUEST,
  DOWNLOAD_INVOICE_SUCCESS,
  DOWNLOAD_INVOICE_FAIL,
  DOWNLOAD_INVOICE_RESET,
  EMAIL_MULTI_PCC_TICKET_REPORT_REQUEST,
  EMAIL_MULTI_PCC_TICKET_REPORT_SUCCESS,
  EMAIL_MULTI_PCC_TICKET_REPORT_FAIL,
  EMAIL_MULTI_PCC_TICKET_REPORT_RESET,
  GET_CUSTOMER_SUCCESS,
  GET_CUSTOMER_FAIL,
  GET_CUSTOMER_RESET,
  GET_CUSTOMER_REQUEST,
  GET_CUSTOMER_LOGINS_BY_ID_REQUEST,
  GET_CUSTOMER_LOGINS_BY_ID_SUCCESS,
  GET_CUSTOMER_LOGINS_BY_ID_FAIL,
  GET_CUSTOMER_LOGINS_BY_ID_RESET,
  UPDATE_CUSTOMER_USER_DEFAULT_LOGO_REQUEST,
  UPDATE_CUSTOMER_USER_DEFAULT_LOGO_SUCCESS,
  UPDATE_CUSTOMER_USER_DEFAULT_LOGO_FAIL,
  UPDATE_CUSTOMER_USER_DEFAULT_LOGO_RESET,
  GET_CHILD_CUSTOMER_BY_PARENT_ID_REQUEST,
  GET_CHILD_CUSTOMER_BY_PARENT_ID_SUCCESS,
  GET_CHILD_CUSTOMER_BY_PARENT_ID_FAIL,
  GET_CHILD_CUSTOMER_BY_PARENT_ID_RESET,
  GET_ALL_CUSTOMERS_REQUEST,
  GET_ALL_CUSTOMERS_SUCCESS,
  GET_ALL_CUSTOMERS_FAIL,
  GET_ALL_CUSTOMERS_RESET,
  GET_CUSTOMER_USER_LOGS_REQUEST,
  GET_CUSTOMER_USER_LOGS_SUCCESS,
  GET_CUSTOMER_USER_LOGS_FAIL,
  GET_CUSTOMER_USER_LOGS_RESET,
  GET_CUSTOMER_STATIC_DATA_REQUEST,
  GET_CUSTOMER_STATIC_DATA_SUCCESS,
  GET_CUSTOMER_STATIC_DATA_FAIL,
  GET_CUSTOMER_STATIC_DATA_RESET,
  GET_CUSTOMER_LOGO_BY_CUST_LOGIN_ID_REQUEST,
  GET_CUSTOMER_LOGO_BY_CUST_LOGIN_ID_SUCCESS,
  GET_CUSTOMER_LOGO_BY_CUST_LOGIN_ID_FAIL,
  GET_CUSTOMER_LOGO_BY_CUST_LOGIN_ID_RESET,
  DELETE_CUSTOMER_LOGO_REQUEST,
  DELETE_CUSTOMER_LOGO_SUCCESS,
  DELETE_CUSTOMER_LOGO_FAIL,
  DELETE_CUSTOMER_LOGO_RESET,
  UPDATE_CUSTOMER_DEFAULT_LOGO_REQUEST,
  UPDATE_CUSTOMER_DEFAULT_LOGO_SUCCESS,
  UPDATE_CUSTOMER_DEFAULT_LOGO_FAIL,
  UPDATE_CUSTOMER_DEFAULT_LOGO_RESET,
} from "../../Constants/Constants";

export const CustomerLoginReducer = (state = {}, action) => {
  switch (action.type) {
    case CUSTOMER_LOGIN_REQUEST:
      return {
        loginloading: true,
      };
    case CUSTOMER_LOGIN_SUCCESS:
      return {
        loading: false,
        token: action.payload,
      };
    case CUSTOMER_LOGIN_FAIL:
      return {
        loading: false,
        loginerror: action.payload,
      };
    case CUSTOMER_LOGIN_RESET:
      return {};
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const SendOTPReducer = (state = {}, action) => {
  switch (action.type) {
    case SEND_OTP_REQUECT:
      return {
        sendOTPloading: true,
      };
    case SEND_OTP_SUCCESS:
      return {
        sendOTPloading: false,
        sendOTPInfo: action.payload,
      };
    case SEND_OTP_FAIL:
      return {
        sendOTPloading: false,
        sendOTPerror: action.payload,
      };
    case SEND_OTP_RESET:
      return {};
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const GetLoggedInCustomerReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_LOGGED_IN_CUSTOMER_REQUEST:
      return {
        loading: true,
      };
    case GET_LOGGED_IN_CUSTOMER_SUCCESS:
      return {
        loading: false,
        loggedInCustomerInfo: action.payload,
      };
    case GET_LOGGED_IN_CUSTOMER_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_LOGGED_IN_CUSTOMER_RESET:
      return {
        loggedInCustomerInfo: {},
      };
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const ChangePasswordReducer = (state = {}, action) => {
  switch (action.type) {
    case CHANGE_PASSWORD_REQUEST:
      return {
        loading: true,
      };
    case CHANGE_PASSWORD_SUCCESS:
      return {
        loading: false,
        changePasswordInfo: action.payload,
      };
    case CHANGE_PASSWORD_FAIL:
      return {
        loading: false,
        changePasswordError: action.payload,
      };
    case CHANGE_PASSWORD_RESET:
      return {};
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

// Create new customer user
export const CreateCustomerUserReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_CUSTOMER_USER_REQUEST:
      return {
        loading: true,
      };
    case CREATE_CUSTOMER_USER_SUCCESS:
      return {
        loading: false,
        createCustomerUserInfo: action.payload,
      };
    case CREATE_CUSTOMER_USER_FAIL:
      return {
        loading: false,
        createCustomerUserError: action.payload,
      };
    case CREATE_CUSTOMER_USER_RESET:
      return {};
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

// Get all the customers users
export const GetCustomerUsersReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_CUSTOMER_USERS_REQUEST:
      return {
        loading: true,
      };
    case GET_CUSTOMER_USERS_SUCCESS:
      return {
        loading: false,
        customerUsersInfo: action.payload,
      };
    case GET_CUSTOMER_USERS_FAIL:
      return {
        loading: false,
        customerUsersError: action.payload,
      };
    case GET_CUSTOMER_USERS_RESET:
      return {};
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

// Get customer user by id
export const GetCustomerUserByIdReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_CUSTOMER_USER_BY_ID_REQUEST:
      return {
        loading: true,
      };
    case GET_CUSTOMER_USER_BY_ID_SUCCESS:
      return {
        loading: false,
        customerUserByIdInfo: action.payload,
      };
    case GET_CUSTOMER_USER_BY_ID_FAIL:
      return {
        loading: false,
        customerUserByIdError: action.payload,
      };
    case GET_CUSTOMER_USER_BY_ID_RESET:
      return {};
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

// Update customer user
export const UpdateCustomerUserReducer = (
  state = { loading: false, success: false, message: {} },
  action
) => {
  switch (action.type) {
    case UPDATE_CUSTOMER_USER_REQUEST:
      return {
        loading: true,
      };
    case UPDATE_CUSTOMER_USER_SUCCESS:
      return {
        loading: false,
        success: true,
        updateCustomerUserInfo: action.payload,
      };
    case UPDATE_CUSTOMER_USER_FAIL:
      return {
        loading: false,
        updateCustomerUserError: action.payload,
      };
    case UPDATE_CUSTOMER_USER_RESET:
      return {};
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

// Delete customer user
export const DeleteCustomerUserReducer = (state = {}, action) => {
  switch (action.type) {
    case DELETE_CUSTOMER_USER_REQUEST:
      return {
        loading: true,
      };
    case DELETE_CUSTOMER_USER_SUCCESS:
      return {
        loading: false,
        success: true,
        deleteCustomerUserInfo: action.payload,
      };
    case DELETE_CUSTOMER_USER_FAIL:
      return {
        loading: false,
        deleteCustomerUserError: action.payload,
      };
    case DELETE_CUSTOMER_USER_RESET:
      return {};
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

// Get customer user permissions
export const GetCustomerUserPermissionsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_CUSTOMER_USER_PERMISSION_REQUEST:
      return {
        loading: true,
      };
    case GET_CUSTOMER_USER_PERMISSION_SUCCESS:
      return {
        loading: false,
        customerUserPermissionsInfo: action.payload,
      };
    case GET_CUSTOMER_USER_PERMISSION_FAIL:
      return {
        loading: false,
        customerUserPermissionsError: action.payload,
      };
    case GET_CUSTOMER_USER_PERMISSION_RESET:
      return {};
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

// Get logged in customer logins
export const GetLoggedInCustomerLoginsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_LOGGED_IN_CUSTOMER_LOGINS_REQUEST:
      return {
        loading: true,
      };
    case GET_LOGGED_IN_CUSTOMER_LOGINS_SUCCESS:
      return {
        loading: false,
        loggedInCustomerLoginsInfo: action.payload,
      };
    case GET_LOGGED_IN_CUSTOMER_LOGINS_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_LOGGED_IN_CUSTOMER_LOGINS_RESET:
      return {
        loggedInCustomerLoginsInfo: {},
      };
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

// Update Customer profile
export const UpdateCustomerProfileReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_CUSTOMER_PROFILE_REQUEST:
      return {
        loading: true,
      };
    case UPDATE_CUSTOMER_PROFILE_SUCCESS:
      return {
        loading: false,
        updateCustomerProfileInfo: action.payload,
      };
    case UPDATE_CUSTOMER_PROFILE_FAIL:
      return {
        loading: false,
        updateCustomerProfileError: action.payload,
      };
    case UPDATE_CUSTOMER_PROFILE_RESET:
      return {};
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

// Get all counties
export const GetAllCountryReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ALL_COUNTRY_REQUEST:
      return {
        loading: true,
      };
    case GET_ALL_COUNTRY_SUCCESS:
      return {
        loading: false,
        countryInfo: action.payload,
      };
    case GET_ALL_COUNTRY_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_ALL_COUNTRY_RESET:
      return {
        countryInfo: {},
      };
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

// Change password from profile
export const ChangePasswordFromProfileReducer = (state = {}, action) => {
  switch (action.type) {
    case CHANGE_PASSWORD_FROM_PROFILE_REQUEST:
      return {
        loading: true,
      };
    case CHANGE_PASSWORD_FROM_PROFILE_SUCCESS:
      return {
        loading: false,
        changePasswordFromProfileInfo: action.payload,
      };
    case CHANGE_PASSWORD_FROM_PROFILE_FAIL:
      return {
        loading: false,
        changePasswordFromProfileError: action.payload,
      };
    case CHANGE_PASSWORD_FROM_PROFILE_RESET:
      return {};
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

// Get Manage Booking Data
export const GetManageBookingDataReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_MANAGE_BOOKING_DATA_REQUEST:
      return {
        loading: true,
      };
    case GET_MANAGE_BOOKING_DATA_SUCCESS:
      return {
        loading: false,
        itineraryInfo: action.payload,
      };
    case GET_MANAGE_BOOKING_DATA_FAIL:
      return {
        loading: false,
        error: action.payload?.response?.data,
      };
    case GET_MANAGE_BOOKING_DATA_RESET:
      return {
        itineraryInfo: {},
      };
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

// Check logged in user pcc
export const CheckLoggedInUserPCCReducer = (state = {}, action) => {
  switch (action.type) {
    case CHECK_LOGGED_IN_USER_PCC_REQUEST:
      return {
        loading: true,
      };
    case CHECK_LOGGED_IN_USER_PCC_SUCCESS:
      return {
        loading: false,
        loggedInUserPCCInfo: action.payload,
      };
    case CHECK_LOGGED_IN_USER_PCC_FAIL:
      return {
        loading: false,
        loggedInUserPCCerror: action.payload,
      };
    case CHECK_LOGGED_IN_USER_PCC_RESET:
      return {
        loggedInUserPCCInfo: {},
      };
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const PrintItineraryDataReducer = (state = {}, action) => {
  switch (action.type) {
    case PRINT_ITINERARY_DATA_REQUEST:
      return {
        printItineraryLoading: true,
      };
    case PRINT_ITINERARY_DATA_SUCCESS:
      return {
        printItineraryLoading: false,
        printItineraryInfo: action.payload,
      };
    case PRINT_ITINERARY_DATA_FAIL:
      return {
        printItineraryLoading: false,
        printItineraryError: action.payload,
      };
    case PRINT_ITINERARY_DATA_RESET:
      return {};
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const EmailItineraryDataReducer = (state = {}, action) => {
  switch (action.type) {
    case EMAIL_ITINERARY_DATA_REQUEST:
      return {
        emailItineraryLoading: true,
      };
    case EMAIL_ITINERARY_DATA_SUCCESS:
      return {
        emailItineraryLoading: false,
        emailItineraryInfo: action.payload,
      };
    case EMAIL_ITINERARY_DATA_FAIL:
      return {
        emailItineraryLoading: false,
        emailItineraryError: action.payload,
      };
    case EMAIL_ITINERARY_DATA_RESET:
      return {};
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const CheckCustomerUserUsernameAvailabilityReducer = (
  state = {},
  action
) => {
  switch (action.type) {
    case CHECK_CUSTOMER_USER_USERNAME_AVAILABILITY_REQUEST:
      return {
        loading: true,
      };
    case CHECK_CUSTOMER_USER_USERNAME_AVAILABILITY_SUCCESS:
      return {
        loading: false,
        checkCustomerUserUsernameInfo: action.payload,
        available: true,
      };
    case CHECK_CUSTOMER_USER_USERNAME_AVAILABILITY_FAIL:
      return {
        loading: false,
        checkCustomerUserUsernameError: action.payload,
        available: false,
      };
    case CHECK_CUSTOMER_USER_USERNAME_AVAILABILITY_RESET:
      return {};
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const GetLoggedInCustomerUserReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_LOGGED_IN_CUSTOMER_USER_REQUEST:
      return {
        loading: true,
      };
    case GET_LOGGED_IN_CUSTOMER_USER_SUCCESS:
      return {
        loading: false,
        loggedInCustomerUserInfo: action.payload,
      };
    case GET_LOGGED_IN_CUSTOMER_USER_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_LOGGED_IN_CUSTOMER_USER_RESET:
      return {};
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const UpdateCustomerUserProfileReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_CUSTOMER_USER_PROFILE_REQUEST:
      return {
        loading: true,
      };
    case UPDATE_CUSTOMER_USER_PROFILE_SUCCESS:
      return {
        loading: false,
        updateCustomerUserProfileInfo: action.payload,
      };
    case UPDATE_CUSTOMER_USER_PROFILE_FAIL:
      return {
        loading: false,
        updateCustomerUserProfileError: action.payload,
      };
    case UPDATE_CUSTOMER_USER_PROFILE_RESET:
      return {};
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const GetCustomerUserLogosReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_CUSTOMER_USER_LOGOS_REQUEST:
      return {
        loading: true,
      };
    case GET_CUSTOMER_USER_LOGOS_SUCCESS:
      return {
        loading: false,
        customerUserLogosInfo: action.payload,
      };
    case GET_CUSTOMER_USER_LOGOS_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_CUSTOMER_USER_LOGOS_RESET:
      return {
        customerUserLogosInfo: {},
      };
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

// delete customer user logo
export const DeleteCustomerUserLogoReducer = (state = {}, action) => {
  switch (action.type) {
    case DELETE_CUSTOMER_USER_LOGO_REQUEST:
      return {
        loading: true,
      };
    case DELETE_CUSTOMER_USER_LOGO_SUCCESS:
      return {
        loading: false,
        deleteCustomerUserLogoInfo: action.payload,
      };
    case DELETE_CUSTOMER_USER_LOGO_FAIL:
      return {
        loading: false,
        deleteCustomerUserLogoError: action.payload,
      };
    case DELETE_CUSTOMER_USER_LOGO_RESET:
      return {};
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

// Get Ticket report data
export const GetTicketReportDataReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_TICKET_REPORT_REQUEST:
      return {
        loading: true,
      };
    case GET_TICKET_REPORT_SUCCESS:
      return {
        loading: false,
        ticketReportData: action.payload,
      };
    case GET_TICKET_REPORT_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_TICKET_REPORT_RESET:
      return {};
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const GetTpBatchReportDataReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_TP_BATCH_REPORT_REQUEST:
      return {
        loading: true,
      };
    case GET_TP_BATCH_REPORT_SUCCESS:
      return {
        loading: false,
        tpBatchReportData: action.payload,
      };
    case GET_TP_BATCH_REPORT_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_TP_BATCH_REPORT_RESET:
      return {};
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const GetCurrencyReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_CURRENCY_REQUEST:
      return {
        loading: true,
      };
    case GET_CURRENCY_SUCCESS:
      return {
        loading: false,
        currencyInfo: action.payload,
      };
    case GET_CURRENCY_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_CURRENCY_RESET:
      return {
        currencyInfo: {},
      };
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

// Download Excel file
export const DownloadExcelFileReducer = (state = {}, action) => {
  switch (action.type) {
    case DOWNLOAD_EXCEL_REQUEST:
      return {
        downloadExcelLoading: true,
      };
    case DOWNLOAD_EXCEL_SUCCESS:
      return {
        downloadExcelLoading: false,
        excelFile: action.payload,
      };
    case DOWNLOAD_EXCEL_FAIL:
      return {
        downloadExcelLoading: false,
        downloadExcelError: action.payload,
      };
    case DOWNLOAD_EXCEL_RESET:
      return {};
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

// Download CSV file
export const DownloadCSVFileReducer = (state = {}, action) => {
  switch (action.type) {
    case DOWNLOAD_CSV_REQUEST:
      return {
        downloadCSVLoading: true,
      };
    case DOWNLOAD_CSV_SUCCESS:
      return {
        downloadCSVLoading: false,
        CSVFile: action.payload,
      };
    case DOWNLOAD_CSV_FAIL:
      return {
        downloadCSVLoading: false,
        downloadCSVError: action.payload,
      };
    case DOWNLOAD_CSV_RESET:
      return {};
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const InvoiceDisplayReducer = (state = {}, action) => {
  switch (action.type) {
    case DOWNLOAD_INVOICE_REQUEST:
      return {
        invoiceLoading: true,
        invoiceError: null,
        invoiceData: null,
      };
    case DOWNLOAD_INVOICE_SUCCESS:
      return {
        invoiceLoading: false,
        invoiceData: action.payload,
        invoiceError: null,
      };
    case DOWNLOAD_INVOICE_FAIL:
      return {
        invoiceLoading: false,
        invoiceError: action.payload,
        invoiceData: null,
      };
    case DOWNLOAD_INVOICE_RESET:
      return {};
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const EmailMultiPccTicketReportReducer = (state = {}, action) => {
  switch (action.type) {
    case EMAIL_MULTI_PCC_TICKET_REPORT_REQUEST:
      return {
        loading: true,
      };
    case EMAIL_MULTI_PCC_TICKET_REPORT_SUCCESS:
      return {
        loading: false,
        emailMultiPccTicketReportInfo: action.payload,
      };
    case EMAIL_MULTI_PCC_TICKET_REPORT_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case EMAIL_MULTI_PCC_TICKET_REPORT_RESET:
      return {};
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

// Get customer by id
export const GetCustomerByIdReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_CUSTOMER_REQUEST:
      return {
        loading: true,
      };
    case GET_CUSTOMER_SUCCESS:
      return {
        loading: false,
        customerInfo: action.payload,
      };
    case GET_CUSTOMER_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_CUSTOMER_RESET:
      return {};
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

// Get customer logins by ud
export const GetCustomerLoginsByIdReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_CUSTOMER_LOGINS_BY_ID_REQUEST:
      return {
        loading: true,
      };
    case GET_CUSTOMER_LOGINS_BY_ID_SUCCESS:
      return {
        loading: false,
        customerLoginsInfo: action.payload,
      };
    case GET_CUSTOMER_LOGINS_BY_ID_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_CUSTOMER_LOGINS_BY_ID_RESET:
      return {};
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

// Update customer user default logo
export const UpdateCustomerUserDefaultLogoReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_CUSTOMER_USER_DEFAULT_LOGO_REQUEST:
      return {
        loading: true,
      };
    case UPDATE_CUSTOMER_USER_DEFAULT_LOGO_SUCCESS:
      return {
        loading: false,
        updateCustomerUserDefaultLogoInfo: action.payload,
      };
    case UPDATE_CUSTOMER_USER_DEFAULT_LOGO_FAIL:
      return {
        loading: false,
        updateCustomerUserDefaultLogoError: action.payload,
      };
    case UPDATE_CUSTOMER_USER_DEFAULT_LOGO_RESET:
      return {};
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

// Get all child customer by parent id
export const GetChildCustomerByParentIdReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_CHILD_CUSTOMER_BY_PARENT_ID_REQUEST:
      return {
        loading: true,
      };
    case GET_CHILD_CUSTOMER_BY_PARENT_ID_SUCCESS:
      return {
        loading: false,
        childCustomerInfo: action.payload,
      };
    case GET_CHILD_CUSTOMER_BY_PARENT_ID_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_CHILD_CUSTOMER_BY_PARENT_ID_RESET:
      return {};
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

// get customers
export const GetCustomersReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ALL_CUSTOMERS_REQUEST:
      return {
        loading: true,
      };
    case GET_ALL_CUSTOMERS_SUCCESS:
      return {
        loading: false,
        customersInfo: action.payload,
      };
    case GET_ALL_CUSTOMERS_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_ALL_CUSTOMERS_RESET:
      return {
        customersInfo: {},
      };
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

// get customer user logs
export const GetCustomerUserLogsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_CUSTOMER_USER_LOGS_REQUEST:
      return {
        loading: true,
      };
    case GET_CUSTOMER_USER_LOGS_SUCCESS:
      return {
        loading: false,
        customerUserLogsInfo: action.payload,
      };
    case GET_CUSTOMER_USER_LOGS_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_CUSTOMER_USER_LOGS_RESET:
      return {
        customerUserLogsInfo: {},
      };
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const GetCustomerStaticDataByCustIDReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_CUSTOMER_STATIC_DATA_REQUEST:
      return {
        loading: true,
      };
    case GET_CUSTOMER_STATIC_DATA_SUCCESS:
      return {
        loading: false,
        customerStaticDataInfo: action.payload,
      };
    case GET_CUSTOMER_STATIC_DATA_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_CUSTOMER_STATIC_DATA_RESET:
      return {
        customerStaticDataInfo: {},
      };
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

// Get customer logos
export const GetCustomerLogosReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_CUSTOMER_LOGO_BY_CUST_LOGIN_ID_REQUEST:
      return {
        loading: true,
      };
    case GET_CUSTOMER_LOGO_BY_CUST_LOGIN_ID_SUCCESS:
      return {
        loading: false,
        customerLogosInfo: action.payload,
      };
    case GET_CUSTOMER_LOGO_BY_CUST_LOGIN_ID_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_CUSTOMER_LOGO_BY_CUST_LOGIN_ID_RESET:
      return {
        customerLogosInfo: {},
      };
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

// Delete customer logo
export const DeleteCustomerLogoReducer = (state = {}, action) => {
  switch (action.type) {
    case DELETE_CUSTOMER_LOGO_REQUEST:
      return {
        loading: true,
      };
    case DELETE_CUSTOMER_LOGO_SUCCESS:
      return {
        loading: false,
        deleteCustomerLogoInfo: action.payload,
      };
    case DELETE_CUSTOMER_LOGO_FAIL:
      return {
        loading: false,
        deleteCustomerLogoError: action.payload,
      };
    case DELETE_CUSTOMER_LOGO_RESET:
      return {};
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};

// Update customer default logo
export const UpdateCustomerDefaultLogoReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_CUSTOMER_DEFAULT_LOGO_REQUEST:
      return {
        loading: true,
      };
    case UPDATE_CUSTOMER_DEFAULT_LOGO_SUCCESS:
      return {
        loading: false,
        updateCustomerDefaultLogoInfo: action.payload,
      };
    case UPDATE_CUSTOMER_DEFAULT_LOGO_FAIL:
      return {
        loading: false,
        updateCustomerDefaultLogoError: action.payload,
      };
    case UPDATE_CUSTOMER_DEFAULT_LOGO_RESET:
      return {};
    case CUSTOMER_LOGOUT:
      return {};
    default:
      return state;
  }
};
